module.exports = __webpack_public_path__ + "static/media/icon-trunk.12b47eb6.svg";